import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { message } from 'antd';
import { InputField, SelectInput } from '../../blueplanitUtils/InputField';
import Modal from '../../blueplanitUtils/Modal';
import { updateEmpLeaveSettingsThunk } from '../../Slices/LeavesSlice';
const ProfileLeaveSettingsModal = () => {

  const dispatch = useDispatch();
  const { Empid } = useParams();
  const department = useSelector((state) => state.employee.userData.department);
  const employeeLeaves = useSelector((state) => state.employee.filteredLeaveData);
  const year = new Date().getFullYear().toString();

  const [basicValid, setBasicValid] = useState(false);
  const [leaveData, setLeaveData] = useState({
    casualLeaves: "",
    CarryforwardLeaves: "",
    medicalLeave: "",
    carryFlag: false,
  });

  useEffect(() => {
    if (employeeLeaves) {
      setLeaveData((prevData) => ({
        ...prevData,
        casualLeaves: employeeLeaves.casualLeaves,
        CarryforwardLeaves: employeeLeaves.carryFlag ? employeeLeaves.CarryforwardLeaves : "",
        medicalLeave: employeeLeaves.medicalLeave,
        carryFlag: employeeLeaves.carryFlag,
      }));
    } else {
      setLeaveData({
        casualLeaves: "",
        CarryforwardLeaves: "",
        medicalLeave: "",
        carryFlag: false,
      });
    }
  }, [employeeLeaves]);


  const handleLeaveInputChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;


    setLeaveData((prev) => ({ ...prev, [name]: updatedValue }));
    setBasicValid(true);
  };

  const handleClose = (type) => {

  };


  const handleLeaveInfoSubmit = async (e) => {
    e.preventDefault();


    setBasicValid(true);
    try {
      await dispatch(
        updateEmpLeaveSettingsThunk({
          variables: {
            id: Empid,
            input: {
              ...leaveData,
              department,
              year,
              Key: true,
            }
          },
          year,
          department,
        })
      ).unwrap();

      message.success({
        content: "Leaves updated successfully!",
        duration: 5,
      });

      setBasicValid(false);
    } catch (err) {
      console.error("Error:", err);
      message.error({
        content: "Failed to update leaves.",
        duration: 5,
      });
    }
  }
  return (
    <Modal
      id="leave_settings_modal"
      title="Leave Information"
      handleModalClose={handleClose}
      handleSubmit={handleLeaveInfoSubmit}
      isUserDataValid={basicValid}
    >
      <div className="row">
        {/* Casual Leaves */}
        <div className="col-md-6">
          <div className="input-block mb-3">

            <InputField
              label={"Casual Leaves"}
              required={true}
              type="number"
              className="form-control"
              name="casualLeaves"
              value={leaveData.casualLeaves}
              onChange={handleLeaveInputChange}

            />
          </div>
        </div>

        {/* Medical Leave */}
        <div className="col-md-6">
          <div className="input-block mb-3">

            <InputField
              label="Medical Leave"
              required={true}
              type="number"
              className="form-control"
              name="medicalLeave"
              value={leaveData.medicalLeave}
              onChange={handleLeaveInputChange}

            />
          </div>
        </div>

        {/* Carryforward Flag */}
        <div className="col-md-6">

          <SelectInput
            label="Carry Forward"
            required={true}
            className="form-control"
            name="carryFlag"
            value={leaveData?.carryFlag}
            style={{ width: "100%" }}
            onChange={(value) => handleLeaveInputChange({ target: { name: 'carryFlag', value } })}
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false }
            ]}
          />
        </div>

        {/* Carryforward Leaves */}
        <div className="col-md-6">
          <div className="input-block mb-3">
            <InputField
              label={"Carry Forward Leaves"}
              required={true}
              type="number"
              className="form-control"
              disabled={!leaveData.carryFlag}
              name="CarryforwardLeaves"
              value={leaveData.carryFlag ? leaveData.CarryforwardLeaves : ""}
              onChange={handleLeaveInputChange}

            />
          </div>
        </div>
      </div>
      {/* </form> */}
    </Modal>
  );
};

export default ProfileLeaveSettingsModal;
